export default __webpack_public_path__ + "static/media/Snd_TryM.73db80db.mp3";